
export enum BuckinghamshireRecordType  {      
        Consultation = "cons",
        Monument = "mon",
        Event = "event",
        Source = "source",
        Designation = "desig",        
        Hlc_1820 = "hlc1820",
        Hlc_1880 = "hlc1880",
        Hlc_2000 = "hlc2000",
        HistoricRidgeAndFurrow= "hraf"
}  

export enum BuckinghamshireRecordSubType  {   
    ConservationArea = "COA",
    ScheduledMonument = "SAM",
    RegisteredParksAndGardens = "RG",
    ArchaeologicalNotificationAreas = "PLN",
    ListedBuilding = "LB",
    LocallyListedBuilding = "LLB"       
}  
